// plugins/sentry-consent.client.ts
export default defineNuxtPlugin(() => {
	if (!import.meta.client) return

	const config = useRuntimeConfig()
	const envName = config.public?.envName

	// ✅ only in production
	if (import.meta.dev || envName !== 'production') return

	window.addEventListener('cookieyes_consent_update', () => {
		const store = window.cookieyes?._ckyConsentStore
		const analyticsYes = store instanceof Map && store.get('analytics') === 'yes'

		if (analyticsYes) {
			console.info('[Sentry] analytics consent granted')
		}
	})
})
